module.exports = __webpack_public_path__ + "static/media/pdeu_logo.1ae73c7c.png";